import { FormattedMessage } from 'react-intl'

import { ArrowCircleRightIcon } from '@10xLabs/react-web/components/Icons/ArrowCircleRight'
import { LabelWrapper, Label, ReturnTripsWrapper, ReturnIcon } from '../Service'

export const BookingCompanyLine = ({
  departureTrips,
  returnTrips,
  showDepartureTrips,
  showReturnTrips
}: TSFixMe): TSFixMe => {
  if (departureTrips.length === 0) return null

  return (
    <div>
      {showDepartureTrips && (
        <>
          {showReturnTrips && (
            <LabelWrapper>
              <ArrowCircleRightIcon />

              <Label>
                <FormattedMessage id="dictionary.departure" defaultMessage="Departure" />
              </Label>
            </LabelWrapper>
          )}

          <div>{departureTrips[0].companyLine.name}</div>
        </>
      )}

      {showReturnTrips && (
        <ReturnTripsWrapper showDepartureTrips={showDepartureTrips}>
          {showDepartureTrips && (
            <LabelWrapper>
              <ReturnIcon />

              <Label>
                <FormattedMessage id="dictionary.return" defaultMessage="Return" />
              </Label>
            </LabelWrapper>
          )}

          <div>{returnTrips[0].companyLine.name}</div>
        </ReturnTripsWrapper>
      )}
    </div>
  )
}
